import axios from 'axios';
import config from '../../config';

axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN';
const axiosInstance = axios.create({
  baseURL: config.API_BASE_URL,
  timeout: 5000,
});

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => Promise.reject(error),
);

export default axiosInstance;
